import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Icon, Typography } from '@elements';
import { KHLContainerBox, StyledTitle } from './partners.styles';
import { amurPartners, KHLPartners } from './partners.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PartnersComponent = function PartnersComponent() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    py: 4.75,
    children: [/*#__PURE__*/_jsxs(Box, {
      pb: 8,
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        variant: "h2",
        color: "internationalOrange",
        textAlign: "center",
        fontWeight: 500,
        children: t('components.footer.fonbetPartners')
      }), /*#__PURE__*/_jsx(KHLContainerBox, {
        display: "flex",
        gap: 4,
        flexWrap: "wrap",
        pt: 4,
        justifyContent: "center",
        children: KHLPartners.map(function (partner) {
          return /*#__PURE__*/_jsxs(Box, {
            component: "a",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
            href: partner.href,
            target: "_blank",
            rel: "noreferrer",
            sx: {
              textDecoration: 'none',
              '&:hover': {
                opacity: 0.7
              }
            },
            children: [/*#__PURE__*/_jsx(Box, {
              component: "img",
              src: partner.logo,
              alt: partner.name,
              width: 107,
              height: 43,
              sx: {
                width: 107,
                height: 43,
                objectFit: 'contain'
              }
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "body5",
              color: "secondarySilver",
              textAlign: "center",
              children: partner.title
            })]
          }, partner.id);
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        variant: "h2",
        color: "internationalOrange",
        textAlign: "center",
        fontWeight: 500,
        children: t('components.footer.amurPartners')
      }), /*#__PURE__*/_jsx(Box, {
        display: "flex",
        gap: 4,
        flexWrap: "wrap",
        pt: 4,
        justifyContent: "center",
        children: amurPartners.map(function (partner) {
          return /*#__PURE__*/_jsxs(Box, {
            component: "a",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
            href: partner.href,
            target: "_blank",
            rel: "noreferrer",
            sx: {
              textDecoration: 'none',
              '&:hover': {
                opacity: 0.7
              }
            },
            children: [/*#__PURE__*/_jsx(Icon, {
              src: partner.logo,
              width: 107,
              height: 43
            }, partner.id), /*#__PURE__*/_jsx(Typography, {
              variant: "body5",
              color: "secondarySilver",
              textAlign: "center",
              children: partner.title
            })]
          }, partner.id);
        })
      })]
    })]
  });
};

export { PartnersComponent };